import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useMemo, useState } from 'react';
import { EStickyType } from './constants';
export var useStickyProps = function useStickyProps(props) {
  var onBottomStuck = props.onBottomStuck,
    onTopStuck = props.onTopStuck,
    topOffset = props.topOffset,
    bottomOffset = props.bottomOffset;
  var bottom = useMemo(function () {
    return bottomOffset !== null && bottomOffset !== void 0 ? bottomOffset : onBottomStuck ? 0 : undefined;
  }, [bottomOffset, onBottomStuck]);
  var top = useMemo(function () {
    return topOffset !== null && topOffset !== void 0 ? topOffset : onTopStuck ? 0 : undefined;
  }, [topOffset, onTopStuck]);
  var _useState = useState(EStickyType.Simple),
    _useState2 = _slicedToArray(_useState, 2),
    stickyType = _useState2[0],
    setStickyType = _useState2[1];
  useEffect(function () {
    switch (true) {
      case !(onBottomStuck || onTopStuck):
        return setStickyType(EStickyType.Simple);
      case 'IntersectionObserver' in window:
        return setStickyType(EStickyType.Modern);
      default:
        return setStickyType(EStickyType.Old);
    }
  }, [onBottomStuck, onTopStuck]);
  return {
    bottom: bottom,
    top: top,
    stickyType: stickyType
  };
};